import React, { useEffect } from "react";

import {
  DataGridPro,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  useGridApiRef,
} from "@mui/x-data-grid-pro"; // Changed to Pro package
import {
  styled,
  alpha,
  Radio,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import {
  stuff_columns, stuff_columns_mobile,
} from "./utils/ColumnDefs";

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGridPro)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: { 
    backgroundColor: theme.palette.grey[200],
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity
      ),
      "&:hover": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity
      ),
      "&:hover": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  },
}))




export default function StuffBoard(props: any) {
  const apiRef = useGridApiRef(); // Added for Pro API access



  const [level, setLevel] = React.useState("AAA");
  const [season, setSeason] = React.useState("2026");
  const [stuffData, setStuffData] = React.useState<Array<any>>([]);

  const columns = props.isDesktop ? stuff_columns : stuff_columns_mobile;

  const handleLevel = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLevel(event.target.value);
  };
  //console.log(level);

  const handleSeason = (event: SelectChangeEvent) => {
    setSeason(event.target.value as string);
  };
  //console.log(season);

  const [organization, setOrganization] = React.useState("All");

  const handleOrganization = (event: SelectChangeEvent) => {
    setOrganization(event.target.value as string);
  };

  const [minPitches, setMinPitches] = React.useState("100");

  const handleMinPitches = (event: SelectChangeEvent) => {
    setMinPitches(event.target.value as string);
  };


  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ backgroundColor: "#FFFFFF" }}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
        />
        {/* Added Quick Filter */}
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) =>
            searchInput.split(',').map((value) => value.trim())
          }
          sx={{ marginLeft: 'auto', width: props.isDesktop ? 500 : 250 }}
        />
        {level === "A" && (
          <div>
            <span style={{ fontWeight: "bold", color: "#DC707A" }}>
              ** Only 10 Organizations (those of the Florida State League) Have Single A Data Available **
            </span>
          </div>
        )}
      </GridToolbarContainer>
    );
  }


  useEffect(() => {
    //console.log("Data: ", level);

    fetch(props.prod ? "https://oriolebird.pythonanywhere.com/stored_stuff/" + level + "/" + season + "/"  : "/stored_stuff/" + level + "/" + season + "/", {
      headers: { Authorization: `Bearer ${localStorage.getItem("ps_token") ?? ""}` },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.data);
        setStuffData(data.data);
      });
  }, [level, props.prod, season]);

  return (
    <div style={{ width: "100%" }}>
      <title>Prospect Savant</title>
      <meta
        name="description"
        content="Prospect Savant - Minor League Baseball Savant"
      />
      <meta
        name="title"
        content="Prospect Savant"
      />
      <meta property="og:description" content="Prospect Savant - Minor League Baseball Savant" />
      <meta property="og:title" content="Prospect Savant" />
        <div
          style={{
            marginTop: "10px",
            marginBottom: "-20px",
            marginLeft: "30px",
            verticalAlign: "baseline",
          }}
        >
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">Level</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="A"
                control={
                  <Radio
                    checked={level === "A"}
                    onChange={handleLevel}
                    value="A"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "A" }}
                  />
                }
                label="A"
              />
              <FormControlLabel
                value="AAA"
                control={
                  <Radio
                    checked={level === "AAA"}
                    onChange={handleLevel}
                    value="AAA"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "AAA" }}
                  />
                }
                label="AAA"
              />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <InputLabel id="demo-simple-select-label">Season</InputLabel>
            <Select
              value={season}
              label="Season"
              onChange={handleSeason}
              defaultValue="2026"
            >
              <MenuItem value={2026}>2026</MenuItem>
              <MenuItem value={2025}>2025</MenuItem>
              <MenuItem value={2024}>2024</MenuItem>
              <MenuItem value={2023}>2023</MenuItem>
            </Select>
          </FormControl>

          {!props.isDesktop && <br></br>}

          <FormControl style={{ marginLeft: "10px" }}>
            <InputLabel id="min-pitches-label">Min Pitches</InputLabel>
            <Select
              value={minPitches}
              label="Min Pitches"
              onChange={handleMinPitches}
              defaultValue="100"
              sx={{ width: "105px" }}
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={150}>150</MenuItem>
              <MenuItem value={200}>200</MenuItem>
              <MenuItem value={250}>250</MenuItem>
              <MenuItem value={300}>300</MenuItem>
              <MenuItem value={400}>400</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>

          <FormControl style={{ marginLeft: "10px" }}>
            <InputLabel id="demo-simple-select-label">Organization</InputLabel>
            <Select
              value={organization}
              label="Organization"
              onChange={handleOrganization}
              defaultValue="All"
              sx={{ width: "100px", }}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"ARI"}>ARI</MenuItem>
              <MenuItem value={"ATL"}>ATL</MenuItem>
              <MenuItem value={"ATH"}>ATH</MenuItem>
              <MenuItem value={"BAL"}>BAL</MenuItem>
              <MenuItem value={"BOS"}>BOS</MenuItem>
              <MenuItem value={"CHC"}>CHC</MenuItem>
              <MenuItem value={"CHW"}>CHW</MenuItem>
              <MenuItem value={"CIN"}>CIN</MenuItem>
              <MenuItem value={"CLE"}>CLE</MenuItem>
              <MenuItem value={"COL"}>COL</MenuItem>
              <MenuItem value={"DET"}>DET</MenuItem>
              <MenuItem value={"HOU"}>HOU</MenuItem>
              <MenuItem value={"KCR"}>KCR</MenuItem>
              <MenuItem value={"LAA"}>LAA</MenuItem>
              <MenuItem value={"LAD"}>LAD</MenuItem>
              <MenuItem value={"MIA"}>MIA</MenuItem>
              <MenuItem value={"MIL"}>MIL</MenuItem>
              <MenuItem value={"MIN"}>MIN</MenuItem>
              <MenuItem value={"NYM"}>NYM</MenuItem>
              <MenuItem value={"NYY"}>NYY</MenuItem>
              <MenuItem value={"PHI"}>PHI</MenuItem>
              <MenuItem value={"PIT"}>PIT</MenuItem>
              <MenuItem value={"SDP"}>SDP</MenuItem>
              <MenuItem value={"SEA"}>SEA</MenuItem>
              <MenuItem value={"SFG"}>SFG</MenuItem>
              <MenuItem value={"STL"}>STL</MenuItem>
              <MenuItem value={"TBR"}>TBR</MenuItem>
              <MenuItem value={"TEX"}>TEX</MenuItem>
              <MenuItem value={"TOR"}>TOR</MenuItem>
              <MenuItem value={"WSN"}>WSN</MenuItem>
            </Select>
          </FormControl>
        </div>
          <StripedDataGrid
            apiRef={apiRef} // Added for Pro API access
            sx={{
              height: "80vh",
              width: props.isDesktop ? "99%" : "100%",
              marginTop: "20px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            rows={stuffData.filter((row: any) =>
              (organization === "All" || row.MLB_AbbName === organization) &&
              (row.total_pitches ?? 0) >= parseInt(minPitches)
            )}
            columns={columns}
            getRowId={(row) => `${row.id}-${row.pitch_type}`} // Create unique ID from player id + pitch_type
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }

            disableColumnResize={false} // Enable column resizing

            slots={{
              toolbar: CustomToolbar,
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: "psStuff", sort: "desc" }],
              },
              density: "compact",
              pinnedColumns: {
                left: ['name'], // Pin player name by default
              }, // Initial pinned columns
            }}
          />
    </div>
  );
}
